/*
 * Copyright (c) New Cloud Technologies, Ltd., 2013-2024
 *
 * You can not use the contents of the file in any way without New Cloud Technologies, Ltd. written permission.
 * To obtain such a permit, you should contact New Cloud Technologies, Ltd. at https://myoffice.ru/contacts/
 *
 */

import BaseAmrApi from '../BaseAmrApi';
import { BaseCommands, BaseEvents } from '../types';

import { ReadOnlyParams } from './types';

enum OPEN_MODE_FOR_READONLY {
    readonly = 'readonly',
}

export class AmrReadonlyApi extends BaseAmrApi<BaseCommands, BaseEvents> {
    /**
     * @param editorFrame - элемент `<iframe>`, в который встраивается редактор
     * @param origin - window.location.origin
     */
    constructor(editorFrame: HTMLIFrameElement, origin: string) {
        super(editorFrame, origin, ['error', 'pageReloadRequested']);
    }

    /**
     * Открытие документа
     */
    openDocument(params: ReadOnlyParams) {
        const openDocumentParams = this.getOpenParameters(params);
        return this.open({
            mode: OPEN_MODE_FOR_READONLY.readonly,
            ...openDocumentParams,
        });
    }
}

export default AmrReadonlyApi;
